import { RadioButton, RadioButtonGroup } from '@carbon/react';
import { DRAW_SHAPES, type DrawShape } from './create-area-types';
import styles from './create-area-panel.module.scss';

interface DrawnShapeSectionProps {
  shape: DrawShape;
  onShapeChange: (shape: DrawShape) => void;
  /** Held while a shape's vertices are being edited. */
  disabled?: boolean;
}

/**
 * The drawn method's shape choice, under the creation methods as the mock lays it
 * out: the prompt, then Polygon or Circle radius. The Polygons list further down
 * arms the map, says how to draw the shape, and lists what was drawn.
 *
 * @param {DrawnShapeSectionProps} props - The shape choice.
 * @return {JSX.Element} The shape block.
 */
export function DrawnShapeSection({
  shape,
  onShapeChange,
  disabled = false,
}: DrawnShapeSectionProps): JSX.Element {
  return (
    <div className={styles.methodBlock}>
      <p className={styles.methodHint}>Choose the shape to draw on the map.</p>
      <RadioButtonGroup
        name="create-area-draw-shape"
        legendText=""
        aria-label="Shape to draw"
        orientation="vertical"
        valueSelected={shape}
        disabled={disabled}
        onChange={(value: string | number | undefined) =>
          onShapeChange(String(value) as DrawShape)
        }
      >
        {DRAW_SHAPES.map(({ id, title, description }) => (
          <RadioButton
            key={id}
            id={`create-area-draw-shape-${id}`}
            value={id}
            disabled={disabled}
            labelText={
              <span className={styles.optionLabel}>
                <span>{title}</span>
                <span className={styles.optionDescription}>{description}</span>
              </span>
            }
          />
        ))}
      </RadioButtonGroup>
    </div>
  );
}
